import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const links = [
  { to: '/quotes', label: 'SalesBoard', ico: '◧' },
  { to: '/jobs', label: 'JobBoard', ico: '▦' },
  { to: '/customers', label: 'Customers', ico: '◉' },
  { to: '/catalog', label: 'Catalog', ico: '❖' },
];

export default function Layout() {
  const { profile, signOut } = useAuth();
  return (
    <div className="app">
      <aside className="side">
        <div className="brand">
          SIMPLY TOTES
          <small>+ Co · CRM</small>
        </div>
        <nav className="nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to}>
              <span className="ico">{l.ico}</span>
              {l.label}
            </NavLink>
          ))}
          <NavLink to="/account">
            <span className="ico">⚙</span>Account
          </NavLink>
        </nav>
        <div className="side-foot">
          <div>{profile?.full_name}</div>
          <button className="small" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
